import React from 'react';
import styles from './UsernameSuggestionList.module.scss';
import { T } from '@colonist/ui';
/* List of username suggestions when desired is taken */ export const UsernameSuggestionList = ({ suggestions, onSelect })=>{
    if (suggestions.length == 0) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.suggestions
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.title
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:homePage.header.changeUsername.suggestions'
        }
    })), suggestions.map((suggestion, index)=>/*#__PURE__*/ React.createElement("span", {
            key: index,
            className: styles.suggestion,
            onClick: ()=>onSelect(suggestion),
            "data-testid": "username-suggestion"
        }, suggestion)));
};
